/* eslint-disable valid-typeof */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import AuthContext from '../../../context/auth-context'
import { Row, Col } from 'react-bootstrap';
import { Container, Button, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TableSortLabel, Paper, FormControlLabel, Switch, InputBase, Checkbox, Toolbar, Typography, Tooltip, IconButton, Grid } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search'
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Dropdown from 'react-bootstrap/Dropdown'
import mOpname from './UserOpname.controller'
import { FaChevronLeft } from 'react-icons/fa'
import useStyles from '../../../css/useStylesTabel'
import TouchAppIcon from '@material-ui/icons/TouchApp';
import Skeleton from 'react-loading-skeleton';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import { isArray } from "util";
import clsx from 'clsx';
import useToolbarStyles from '../../../css/useToolbarStyles'
import DialogConfirm from '../../../Dialog/DialogConfirm'
import DialogInfo from '../../../Dialog/DialogInfo'

import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const desc = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const stableSort = (array, cmp) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

const getSorting = (order, orderBy) => {
    return order === "desc"
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}

const UserOpname = (props) => {
    var defaultPage = parseInt(props.match.params.page, 10) - 1;
    var defaultrowsPerPage = parseInt(props.match.params.rowsPerPage, 10);
    const kodeoutlet = props.match.params.kodeoutlet;
    // const [state, dispatch] = useReducer(reducer, initialValue)
    const { clientID, token } = useContext(AuthContext)
    const classes = useStyles();
    const [order, setOrder] = React.useState("desc");
    const [orderBy, setOrderBy] = React.useState("idcust");
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(defaultPage);
    const [dense, setDense] = React.useState(true);
    const [rowsPerPage, setRowsPerPage] = React.useState(defaultrowsPerPage);
    const [rows, setRows] = useState([])
    const [search, setSearch] = useState(null)
    const [isRefresh, setIsRefresh] = useState(true)
    const [noData, setNoData] = useState(false)
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const [OpenConfirmInfo, setOpenConfirmInfo] = useState(false)
    const [dataDialog, setdataDialog] = useState()
    const [dialogtext, setDialogtext] = useState()
    const [open, setOpen] = useState(false);
    const [openReset, setOpenReset] = useState(false)
    const [userReset, setUserReset] = useState()
    const [password, setPassword] = useState()
    const addWaiter = () => {
        props.history.push(`/manajemenoutlet/${kodeoutlet}/opname-user-add`);
    }
    const handleEdit = (kode) => {
        props.history.push(`/manajemenoutlet/${kodeoutlet}/opname-user-detail/${kode}/${page + 1}/${rowsPerPage}`)
    }
    const goBack = () => {
        props.history.push(`/manajemenoutlet/${kodeoutlet}`)
    }
    const konfirmasiDelete = (data) => {
        setOpenConfirmDelete(true);
        setdataDialog(data)
        setDialogtext(`<p>Yakin Anda Ingin Menghapus user ${data.username}?<br/>Data tidak dapat dikembalikan setelah berhasil dihapus<p/>`)
    }
    const handleDelete = (data) => {
        mOpname.deleteOpname(kodeoutlet, data.username, clientID, token).then(resp => {
            if (resp) {
                setOpenConfirmDelete(false);
                setOpenConfirmInfo(true)
                setDialogtext(`<p> User ${data.username} berhasil di hapus<p/>`)
                setIsRefresh(true);
            } else {
                setOpenConfirmInfo(true)
                setDialogtext(`<p>Server tidak dapat memenuhi permintaan Anda saat ini. Harap coba beberapa saat lagi<p/>`)
            }
        }).catch(err => {
            if (isArray(err) && err.length > 0) {
                setOpenConfirmInfo(true)
                setDialogtext(`<p>Gagal hapus ${err[0].message}<p/>`)
            } else if (typeof err == 'error') {
                setOpenConfirmInfo(true)
                setDialogtext(`<p>${err.message}<p/>`)
            } else {
                console.log(err);
            }
        })

    }
    useEffect(() => {
        var render = true
        if (isRefresh) {
            mOpname.loadData(kodeoutlet, clientID, token).then(resp => {
                if (render) setRows(resp);
            }).catch(err => {
                console.error(err);
            }).finally(() => setIsRefresh(false))
        }
        return () => {
            render = false
        };
    }, [kodeoutlet, clientID, token, isRefresh]);


    const handleRequestSort = (event, property) => {
        const isDesc = orderBy === property && order === "desc";
        setOrder(isDesc ? "asc" : "desc");
        setOrderBy(property);
    }
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = rows.map(n => n.username);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    }
    const handleClick = (event, username) => {
        const selectedIndex = selected.indexOf(username);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, username);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }

        setSelected(newSelected);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    }

    const handleChangeDense = (event) => {
        setDense(event.target.checked);
    }
    const isSelected = name => selected.indexOf(name) !== -1;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
    const searchHandler = (val) => {
        setSearch(val.target.value)
    }
    const formSubmitHandler = (event) => {
        setNoData(false);
        if (search) {
            mOpname.search(kodeoutlet, search, clientID, token).then(resp => {
                if (resp.length <= 0) {
                    setNoData(true);
                    setRows(resp);
                } else {
                    setNoData(false);
                    setRows(resp);
                }
            })
        } else {
            setIsRefresh(true)
        }
    }
    const loadingRow = [0, 1, 2, 3, 4];

    const headRows = [
        { id: "username", numeric: true, disablePadding: false, label: "Username" },
        { id: "noHp", numeric: true, disablePadding: false, label: "No Hp" },
        { id: "gender", numeric: true, disablePadding: false, label: "Gender" },

    ];

    const EnhancedTableHead = (props) => {
        const {
            classes,
            order,
            orderBy,
            onRequestSort,
            numSelected,
            rowCount,
            onSelectAllClick
        } = props;
        const createSortHandler = property => event => {
            onRequestSort(event, property);
        };
        return (
            <TableHead>
                <TableRow>
                    <TableCell style={{ width: ' 25px' }}>Action</TableCell>
                    {headRows.map(row => (
                        <TableCell key={row.id}>
                            <TableSortLabel
                                active={orderBy === row.id}
                                direction={order}
                                onClick={createSortHandler(row.id)}
                            >
                                {row.label}
                                {orderBy === row.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === "desc" ? "sorted descending" : "sorted ascending"}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }

    EnhancedTableHead.propTypes = {
        classes: PropTypes.object.isRequired,
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.oneOf(["asc", "desc"]).isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired
    };
    const EnhancedTableToolbar = props => {
        const [open, setOpen] = useState(false);
        const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
        const [OpenConfirmInfo, setOpenConfirmInfo] = useState(false)
        const [dataDialog, setdataDialog] = useState()
        const [dialogtext, setDialogtext] = useState()
        const openDialogEdit = () => {
            setOpen(true);
        }
        const classes = useToolbarStyles();
        const { numSelected, itemSelect } = props;
        const konfirmasiDeleteSelecter = (data) => {
            setOpenConfirmDelete(true);
            setdataDialog(data)
            setDialogtext(`<p>Yakin Anda Ingin Menghapus ${data.length} waiter ini?<br/>Data tidak dapat dikembalikan setelah berhasil dihapus<p/>`)
        }
        const deleteSelected = (data) => {
            mOpname.deleteMultiWaiter(kodeoutlet, data, clientID, token).then(resp => {
                setOpenConfirmDelete(false);
                if (resp) {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>${data.length} waiter berhasil di hapus<p/>`)
                } else {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>Server tidak dapat memenuhi permintaan Anda saat ini. Harap coba beberapa saat lagi<p/>`)
                }

            }).catch(err => {
                setOpenConfirmDelete(false);
                if (isArray(err) && err.length > 0) {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>Gagal hapus ${err[0].message}<p/>`)
                } else if (typeof err == 'error') {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>${err.message}<p/>`)
                } else {
                    console.log(err);
                }
            });
        }
        return numSelected > 0 && (
            <Toolbar
                className={clsx(classes.root, {
                    [classes.highlight]: numSelected > 0,
                })}
            >
                <div className={classes.title}>
                    <Typography color="inherit" variant="subtitle1">{numSelected} selected</Typography>
                </div>
                <div className={classes.spacer} />
                <div className={classes.actions}>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <Tooltip title="Edit" flex onClick={openDialogEdit}>
                                <IconButton aria-label="edit">
                                    <EditIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={6}>
                            <Tooltip title="Delete" flex onClick={konfirmasiDeleteSelecter.bind(this, itemSelect)}>
                                <IconButton aria-label="delete">
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </div>
                <DialogConfirm open={openConfirmDelete} setOpen={setOpenConfirmDelete} text={dialogtext} data={dataDialog} oke={deleteSelected} />
                <DialogInfo open={OpenConfirmInfo} setOpen={setOpenConfirmInfo} text={dialogtext} refresh={refreshData} />
            </Toolbar>
        )
    };
    const addMultiple = () => {
        setOpen(true);
    }
    EnhancedTableToolbar.propTypes = {
        numSelected: PropTypes.number.isRequired,
    };
    const refreshData = () => {
        setSelected([])
        setIsRefresh(true)
    }
    const handleReset = (username) => {
        setOpenReset(true)
        setUserReset(username)
    }
    const handleCloseReset = () => {
        setOpenReset(false)
    }
    const handleChangePassword = (ev) => {
        setPassword(ev.target.value)
    }
    const handleResetPassword = () => {
        mOpname.resetPassword(kodeoutlet, clientID, token,userReset,  password).then(resp => {
            if (resp) {
                setOpenConfirmInfo(true)
                setDialogtext(`<p>User ${userReset} berhasil di reset<p/>`)
            } else {
                setOpenConfirmInfo(true)
                setDialogtext(`<p>Server tidak dapat menjalankan perintah Anda saat ini. Silakan coba sesaat lagi<p/>`)
            }
        }).catch(err => {
            if (isArray(err) && err.length > 0) {
                setOpenConfirmInfo(true)
                setDialogtext(`<p>Gagal Simpan : ${err[0].message}<p/>`)
            } else if (typeof err == 'error') {
                setOpenConfirmInfo(true)
                setDialogtext(`<p>${err.message}<p/>`)
            } else {
                console.log(err);
            }
        })
    }
    return (
        <Container>
            <Row>
                <Col xs={12}>
                    <h3 style={{ marginTop: 20, paddingBottom: 10 }} className="border-bottom"><FaChevronLeft onClick={goBack.bind(this)} className="btnBack" />User Opname</h3>
                    <Dropdown>
                        <Dropdown.Toggle id="dropdown-basic">
                            <AddCircleOutlineIcon id="dropdown-basic" /> Tambah
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item><Button title="Edit" variant="contained" className="btnAddManual" onClick={addWaiter}><EditIcon /> Tambah Manual</Button></Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <div className={classes.root}>
                        <Paper className={classes.paper}>
                            <div className="btnTable">
                                <Row>
                                    <Col>
                                        <div className={classes.search}>
                                            <div className={classes.searchIcon}>
                                                <SearchIcon />
                                            </div>
                                            <InputBase onChange={searchHandler}
                                                placeholder="Search…"
                                                classes={{
                                                    root: classes.inputRoot,
                                                    input: classes.inputInput,
                                                }}
                                                inputProps={{ 'aria-label': 'search' }}
                                            />
                                            <Button style={{ float: 'right' }} onClick={formSubmitHandler} variant="contained" color="primary">Cari</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <EnhancedTableToolbar numSelected={selected.length} itemSelect={selected} />
                            <div className={classes.tableWrapper}>
                                <Table
                                    className="table"
                                    aria-labelledby="tableTitle"
                                    size={dense ? "small" : "medium"}
                                >
                                    <EnhancedTableHead
                                        classes={classes}
                                        numSelected={selected.length}
                                        order={order}
                                        orderBy={orderBy}
                                        onSelectAllClick={handleSelectAllClick}
                                        onRequestSort={handleRequestSort}
                                        rowCount={rows.length}
                                    />
                                    <TableBody>
                                        {noData && (
                                            <TableRow style={{ height: 15 * emptyRows }}>
                                                <TableCell colSpan={7} style={{ textAlign: 'center' }}>
                                                    <b>Tidak ada data</b>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                        {rows.length == 0 && !noData && loadingRow.map(el => (
                                            <TableRow
                                                key={el.toString()}
                                                style={{ height: 50 }}
                                            >
                                                <TableCell>
                                                    <Skeleton />
                                                </TableCell>
                                                <TableCell component="th" scope="row" >
                                                    <Skeleton />
                                                </TableCell>
                                                <TableCell>
                                                    <Skeleton />
                                                </TableCell>
                                                <TableCell>
                                                    <Skeleton />
                                                </TableCell>
                                            </TableRow>
                                        ))

                                        }
                                        {stableSort(rows, getSorting(order, orderBy))
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row, index) => {
                                                const isItemSelected = isSelected(row.username);
                                                const labelId = `enhanced-table-checkbox-${index}`;
                                                return (
                                                    <TableRow
                                                        hover
                                                        role="checkbox"
                                                        tabIndex={-1}
                                                        key={index}
                                                    >
                                                        <TableCell>
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                                    <TouchAppIcon id="dropdown-basic" /></Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item><Button title="Edit" variant="contained" style={{ backgroundColor: '#376275', marginRight: 10, color: "#fff", width: '155px' }} onClick={handleEdit.bind(this, row.username)}><EditIcon /> Edit/lihat</Button></Dropdown.Item>
                                                                    <Dropdown.Item><Button title="Edit" variant="contained" style={{ backgroundColor: '#86142c', marginRight: 10, color: "#fff", width: '155px' }} onClick={handleReset.bind(this, row.username)}><RotateLeftIcon /> Reset Password</Button></Dropdown.Item>
                                                                    <Dropdown.Item><Button title="Hapus" variant="contained" style={{ backgroundColor: 'red', marginRight: 10, color: "#fff", width: '155px' }} onClick={konfirmasiDelete.bind(this, row)}><DeleteIcon /> Hapus</Button></Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </TableCell>
                                                        <TableCell component="th" scope="row" >
                                                            {row.username}
                                                        </TableCell>
                                                        <TableCell>
                                                            {row.noHp}
                                                        </TableCell>
                                                        <TableCell>
                                                            {row.gender}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        {emptyRows > 0 && (
                                            <TableRow style={{ height: 49 * emptyRows }}>
                                                <TableCell colSpan={7} />
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </div>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                component="div"
                                count={rows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                backIconButtonProps={{
                                    "aria-label": "previous page"
                                }}
                                nextIconButtonProps={{
                                    "aria-label": "next page"
                                }}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </Paper>
                        <FormControlLabel
                            control={<Switch checked={dense} onChange={handleChangeDense} />}
                            label="Dense padding"
                        />
                    </div>
                </Col>
            </Row>
            <DialogConfirm open={openConfirmDelete} setOpen={setOpenConfirmDelete} text={dialogtext} data={dataDialog} oke={handleDelete} />
            <DialogInfo open={OpenConfirmInfo} setOpen={setOpenConfirmInfo} text={dialogtext} />
            <Dialog open={openReset} onClose={handleCloseReset} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Reset Password</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Username"
                        value={userReset}
                        fullWidth
                    />
                    <TextField
                        autoFocus
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        value={password}
                        onChange={handleChangePassword}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseReset} color="primary">
                        Cancel
      </Button>
                    <Button onClick={handleResetPassword} color="primary">
                        Reset
      </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}
export default UserOpname;
